<div class="row justify-content-center">
    <div class="col-sm-8 col-12">
        <div class="card floating shadow-lg">
            <div class="card-body">
                <h3 class="card-title main-title">Reset your password</h3>
                <div class="row">
                    <div class="col">
                        <div class="form-control-plaintext">
                            Please enter password reset code and your new password.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Password Reset Code*</mat-label>
                            <input matInput [(ngModel)]="resetKey" type="text">
                            <mat-hint><a class="resend" (click)="resend()">Resend Password Reset Code</a></mat-hint>
                        </mat-form-field>
                    </div>
                </div>
                <p class="card-text">
                    <br>Your Password must be at least 6 characters, 1 special character "!", 1 number,
                    one lower case character and one upper case character.</p>
                <div class="row">
                    <div class="col">                        
                        <mat-form-field appearance="outline">
                            <mat-label>New Password*</mat-label>
                            <input matInput [(ngModel)]="newPassword" type="password">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Confirm New Password*</mat-label>
                            <input matInput [(ngModel)]="confirmNewPassword" type="password">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="card-footer nav-footer">
                <div class="col-sm-12 text-center">
                    <a class="btn btn-blue" (click)="submit()">Submit</a>
                    <a class="btn btn-secondary" (click)="backToLogin()">Back to login</a>
                </div>
            </div>
        </div>
    </div>
</div>